import { Eye, EyeOffIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { EDIT_USER_PASSWORD } from "../../Utils/constant";
import { store } from "../../services/service";

export const EditPassword = ({ username }) => {
  const { register, handleSubmit, reset } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const submit = (data) => {
    setIsSubmit(true);
    store(EDIT_USER_PASSWORD, "application/json", {
      ...data,
      username: username,
    })
      .then((res) => {
        document.getElementById(`fermer-modal${username}`).click();
        reset();
        if (res.status === 200) {
          setIsSubmit(null);
          toast.success("Mot de passe modifié");
        }
      })
      .catch((err) => {
        document.getElementById(`fermer-modal${username}`).click();
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee, { duration: 4000 });
      });
  };

  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <form onSubmit={handleSubmit(submit)} className="w-full">
      <div class="space-y-2 my-3">
        <div class="">
          <label className="text-sm font-medium">
            Nouveau mot de passe <span className="text-red-500">*</span>
          </label>
          <div className="mt-2 relative">
            <input
              {...register("newPassword", { required: true })}
              type={show ? "text" : "password"}
              placeholder="Nouveau mot de passe"
              className="input input-bordered w-full h-10 text-sm "
            />
            {show ? (
              <EyeOffIcon
                onClick={() => setShow(!show)}
                className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
              />
            ) : (
              <Eye
                onClick={() => setShow(!show)}
                className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
              />
            )}
          </div>
        </div>

        <div class="">
          <label className="text-sm font-medium">
            Confirmer le mot de passe <span className="text-red-500">*</span>
          </label>
          <div className="mt-2 relative">
            <input
              {...register("passwordConfirm", { required: true })}
              type={showConfirm ? "text" : "password"}
              placeholder="Confirmer mot de passe"
              className="input input-bordered w-full h-10 text-sm "
            />
            {showConfirm ? (
              <EyeOffIcon
                onClick={() => setShowConfirm(!showConfirm)}
                className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
              />
            ) : (
              <Eye
                onClick={() => setShowConfirm(!showConfirm)}
                className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
              />
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmit ? true : false}
          className={`${
            !isSubmit
              ? "text-slate-900 bg-amber-300"
              : "text-slate-800 bg-slate-200 "
          } w-full inline-flex items-center my-3 justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow hover:bg-slate-900 hover:text-white h-9 px-4 py-2`}
        >
          {isSubmit ? "Veuillez patientez... " : "Rénitialiser le mot de passe"}{" "}
          {isSubmit ? (
            <span className="loading loading-dots loading-xs"></span>
          ) : null}
        </button>
      </div>
    </form>
  );
};
